<button (click)="login()" class="btn btn-success">Innskrá</button>
